export class TicketWaitingListInfoDTO {
  id: number;
  ticketId: number;
  name: string;
  surname: string;
  email: string;
  phone: string;
  people: number;
  ticketPriceId?: number;
  accessCode?: string;
  alreadyBuyed?: number;
  inscribingNow?: number;
  userId?: number;
  expirationAt?: string;
}
